import { render, staticRenderFns } from "./ModalTable.vue?vue&type=template&id=8826c906&scoped=true"
import script from "./ModalTable.vue?vue&type=script&lang=js"
export * from "./ModalTable.vue?vue&type=script&lang=js"
import style0 from "./ModalTable.vue?vue&type=style&index=0&id=8826c906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8826c906",
  null
  
)

export default component.exports